// extracted by mini-css-extract-plugin
export default {"container":"SchoolDetails_container__FtAGn","avatar":"SchoolDetails_avatar__A9TYo","avatarbox":"SchoolDetails_avatarbox__jTQXR","txt":"SchoolDetails_txt__Ye-v5"};